import { render, staticRenderFns } from "./GuideBookPaperDescription.vue?vue&type=template&id=0fd50ba5"
import script from "./GuideBookPaperDescription.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports